import React, {ReactNode} from 'react';

import {SortableHeader, Props as SortableHeaderProps} from 'src/components/filter-header/sortable-header';

import Button, {FlatButton} from '@pb/kit-component-button';
import {Dropdown} from '@pb/kit-component-dropdown-v2';
import {Group, Item} from '@pb/kit-component-group';
import {Icon, Icons} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {useShown} from '@pb/kit-hooks-use-shown';

import {section} from './filter-header.module.styl';

type OwnProps = {
    isFilterApplied: boolean,
    onFilterApply: (onClose?: () => void) => void,
    onCancel: (onClose?: () => void) => void,
    resetFilters: (onClose?: () => void) => void,
    children: ReactNode,
};

export type Props = OwnProps & Omit<SortableHeaderProps, 'contentAfter'>;

export const FilterHeader: React.FC<Props> = props => {
    const {
        isFilterApplied,
        onFilterApply,
        onCancel,
        resetFilters,
        caption,
        onSort,
        isSorted,
    } = props;
    const {onToggle, shown, onClose} = useShown();

    const filter = (
        <Dropdown
            anchor={({anchorRef, getAnchorProps}) => (
                <BasicIconButton
                    ref={anchorRef}
                    {...getAnchorProps()}
                    iconProps={{type: isFilterApplied ? Icons.FILTER_FILL : Icons.FILTER}}
                />
            )}
            type="FIXED"
            maxHeight={0}
            hideOnBodyLeave={false}
            shown={shown}
            setShown={onToggle}>
            <Item className="pt-s">
                <Group
                    wrap="wrap-reverse"
                    direction="v"
                    justify="space-between"
                    alignItems="start">
                    {isFilterApplied ? (
                        <FlatButton
                            startIcon={<Icon type={Icons.CLEAR_ALL_FILTERS}/>}
                            onClick={() => resetFilters(onClose)}
                            variant="secondary">
                            Clear Filter
                        </FlatButton>
                    ) : null}
                    {props.children ? (
                        <Item className="pb-sm">
                            {props.children}
                        </Item>
                    ) : null}
                </Group>
            </Item>
            <Item className={`pt-m ${section}`}>
                <Group>
                    <Button onClick={() => onFilterApply(onClose)} variant="Type.PRIMARY">Apply Filters</Button>
                    <Button onClick={() => onCancel(onClose)} variant="Type.SECONDARY">Cancel</Button>
                </Group>
            </Item>
        </Dropdown>
    );

    return (
        <SortableHeader
            {...{
                caption,
                onSort,
                isSorted,
                contentAfter: filter,
            }}
        />
    );
};
